<template>
  <div class="contact_container">
      <Indicator v-if="textList.length > 0" :title="textList[2].title" :content="textList[2].content" counter="04" />
            <!-- <Indicator title="textList[2].title" content="textList[2].content" counter="04" /> -->
    <div class="contact_box">
        <div class="phone" v-if="$mq === 'small'">
            <h3 class="heading">Telefonicznie</h3>
            <h2 class="contact_number">698-088-271</h2>
            <p class="sub">600-830-436</p>
        </div>
        <div class="mail" v-if="$mq === 'small'">
            <h3 class="heading">Mailowo</h3>
            <p class="sub">daniel.meble@wp.pl</p>
        </div>
        <div class="large_container" v-if="$mq != 'small'" >
            <div class="person"></div>
            <div class="person_text">
                <h1 class="person_header">Skontaktuj się z nami.</h1>
                <h2 class="person_medium">Telefonicznie bądź mailowo</h2>
                <h2 class="contact_number">698-088-271</h2>
                <h1 class="contact_number">600-830-436</h1>
                <h2 class="contact_mail">daniel.meble@wp.pl</h2>
            </div>
        </div> 
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Indicator from '../components/Indicator';
export default {
    name: 'ContactUs',
    components:{
        Indicator
    },
    computed:{
        ...mapState({
            textList: state=>state.texts.textList
        })
    }
}
</script>

<style scoped lang="scss">
.contact_box{
    padding: 34px;
    background: linear-gradient(0deg,#00888d,rgba(0,0,0,.7)), url('../assets/contact.jpg');
    background-size: cover;
    background-position: center;
}
.heading, .sub, .person_header, .person_medium, .person_text{
    color: white;
}
@media (min-width: 1440px){
    .contact_box{
        background: none;
        padding: 36px 300px 0 300px;
    }
    .person{
        background: url('../assets/lump.svg');
        background-size: 90%;
        background-repeat: no-repeat;
        background-position: center;
        width: 400px;
        height: 360px;
    }
    .large_container{
        display: flex;
        flex-direction: row;
    }
    .person_text{
        margin-top: 36px;
    }
    .person_header{
        color: black;
        font-size: 36px;
    }
    .person_medium{
        font-size: 22px;
        color: black;
        margin: 12px 0;
    }
    .contact_number, .contact_mail{
        font-size: 22px;
        color: black;
    }
}
</style>